<div *ngIf="tasks.length === 0 && listLoaded">
    <kui-alert type="info"
        class="key-alert-wrapper">
        <kui-icon name="lightbulb" size="sm"></kui-icon>
        <span>{{ 'STATUS.DETAILS.NO_RECENT_TASKS' | translate }}</span>
    </kui-alert>
</div>

<div key-content-container 
    class="d-flex" 
    [scroll]="true"
    #contentContainer>

    <div class="loading-overlay d-flex flex-stretch justify-content-center align-items-center"
        *ngIf="!listLoaded && !errorMessage">
        <kui-loader>
        </kui-loader>
    </div>

    <kui-alert-panel 
        [message]="errorMessage"></kui-alert-panel>

    <div class="flex-1" *ngIf="!errorMessage && listLoaded">
        <div *ngFor="let task of tasks">
            <span class="feed-entry">
                <div kui-action class="d-flex flex-1">
                    <key-feed-entry-info [icons]="[]">
                        <span id="info-title">
                            <span [title]="task.date | getKey: 'created' | date: 'yyyy-MM-dd HH:mm:ss'">{{ task.date |
                                getKey: 'created' | units: { unit: 'time', variant: 'short' } }}</span>
                        </span>
                        <span id="info-small-text" class="small muted">{{ task.date.created | timeAgo }}</span>
                    </key-feed-entry-info>
                    <div class="feed-entry-details">
                        <div class="d-flex flex-wrap">
                            <div class='entry-text flex-1 mr-3 mb-2'>
                                <div class="entry-title accent" [innerHTML]="task.type"></div>
                                <div class="entry-description muted-less">
                                    {{ getDescription(task) }}
                                </div>
                                <div>{{ 'STATUS.DETAILS.TASK_DESC.STATUS' | translate:{ status: task.state } }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </span>
        </div>
    </div>

</div>
<kui-content-header *ngIf="count"
    [custom]="true"
    [sub]="true"
    class="w-100">

    <kui-paginate *ngIf="pageCount > 1"
        class="ml-3"
        [page]="page"
        [total]="count"
        [perPage]="limit"
        [collapse]="true"
        (pageChanged)="onPageChanged($event)"></kui-paginate>

    <div class="ml-auto pr-3">
        {{ count === 1 ? ('STATUS.LIST.ONE_ITEM' | translate) : ('STATUS.LIST.TOTAL_ITEMS' | translate: { total: count }) }}
    </div>

</kui-content-header>